module.exports = __webpack_public_path__ + "img/banneredictos.ca5137cf.jpg";